<template>
  <w-vue-select
    v-bind="{ ...$props, ...$attrs }"
    :title="title"
    :model="$schema.value"
    :values="values"
    :label-field="options.labelField"
    :value-field="options.valueField"
    :input-id="inputId"
    @input="updateValue"
    @search="search"
  />
</template>

<script>
import moment from 'moment';

import { formMixin } from '@/mixins/form';

const schema = {
  properties: {
    value: { type: 'string' }
  }
};

// @vuese
// Autocomplete bez schemy
// @group Form
export default {
  mixins: [formMixin],
  schema,
  props: {
    // Wartość
    value: { type: [String] },
    // Wyświetlany tytuł
    title: { type: String, default: '' },
    // Opcje
    options: { type: Object, required: false },
    // Wartość atrybutu id inputa
    inputId: { type: String, required: false }
  },
  data() {
    return { model: {}, values: this.options.values || [] };
  },
  watch: {
    value(newValue) {
      this.setSchemaData(newValue);
    }
  },
  mounted() {
    this.setSchemaData(this.value);
    this.search(this.value || undefined);
  },
  methods: {
    // @vuese
    // Ustawia wartość w schemie i tym samym na widoku
    setSchemaData(value) {
      if (value === this.$schema.value.$model) {
        return;
      }

      if (!value) {
        this.$schema.value.$setData(null);
      } else if (typeof value === 'string') {
        this.$schema.value.$setData(value);
      }
    },

    // @vuese
    // Ustawia wartość modelu przez emit eventu `input`
    updateValue(newValue) {
      const value = newValue && newValue[this.options.valueField || 'value'];
      this.$emit('input', value);
    },

    // @vuese
    // Wyszukuje pasujące elementy
    search(search) {
      if (this.options?.action) {
        this.$store.dispatch(this.options.action, { ...this.options.actionParams, search }).then(result => {
          if (result.list) {
            result = result.list;
          }
          this.values = result;
        });
      }
    }
  }
};
</script>
